import api from './config';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { logout } from './authSlice';

const initialState = {
  countries: [],
  loading: false,
  error: ''
};

// Countries are always derived server-side from which countries currently have verified
// companies — no hardcoded list here. Passing lat/lng sorts them by proximity to the user.
export const fetchCountries = createAsyncThunk(
  'country/fetchCountries',
  async (params, { rejectWithValue, dispatch }) => {
    const { lat, lng } = params || {};
    try {
      const params = {};
      if (lat != null && lng != null) {
        params.lat = lat;
        params.lng = lng;
      }
      const response = await api.get('/country', { params });
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) dispatch(logout());
      if (!error.response) throw error;
      return rejectWithValue(error.response.data);
    }
  }
);

const countrySlice = createSlice({
  name: 'country',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountries.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchCountries.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.countries = Array.isArray(payload) ? payload : [];
      })
      .addCase(fetchCountries.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload?.message || 'Erreur lors du chargement des pays';
      });
  }
});

export default countrySlice.reducer;
